// extracted by mini-css-extract-plugin
module.exports = {"container":"FullDealOffer_container__woHcu"};